var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"subscriptionMb botPage"},[_c('mbHeader',{attrs:{"title":_vm.$t('email_subscription'),"left":true,"lang":true}}),_vm._v(" "),_c('Subscription'),_vm._v(" "),_c('afwSubscribe')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0e84353c","hasScoped":true,"transformToRequire":{"vue-h-zoom":["image","image-full"]},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/mobile/mobileEmail.vue
// module id = null
// module chunks = 